import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {fileFormClear} from "../../../actions/FileFormActions";

function SimpleFileForm({handleFiles, children}) {
    const dispatch = useDispatch();
    let refFileInput = null;

    useEffect(() => {
        return function cleanup() {
            dispatch(fileFormClear());
        }
    }, []);

    return <span>
        <input
            type="file"
            onChange={event => handleFiles(event.target.files)}
            ref={fileInput => refFileInput = fileInput}
            multiple
            hidden
        />
        {children(() => refFileInput.click())}
    </span>
}

export default SimpleFileForm;